import axios from "axios";
import authHeader from './utils/auth-header';

const API_URL = '/OppPortal/api/v1/portals/leadspaces';

class LeadSpaceDataService {

    getBriefs(clientId) {
        return axios.get(API_URL + `/briefs?clientId=${clientId}`, {headers: authHeader()});
    }

    getFieldValues(clientId, clientName, linkedClass) {
        return axios.get(API_URL + `/fieldvalues?clientId=${clientId}&clientName=${clientName}&linkedClass=${linkedClass}`, {headers: authHeader()});
    }

    findLeadTags(clientId, clientName, searchText) {
        return axios.get(API_URL + `/leadtags?clientId=${clientId}&clientName=${clientName}&searchText=${searchText}`, {headers: authHeader()});
    }

    findAllLeadTags(clientId, clientName) {
        return axios.get(API_URL + `/leadtags?clientId=${clientId}&clientName=${clientName}`, {headers: authHeader()});
    }

    findInfoGroups(clientId) {
        return axios.get(API_URL + `/infogroups?clientId=${clientId}`, {headers: authHeader()});
    }
}

export default new LeadSpaceDataService();